import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface DeleteInvestmentPayload {
  uuid: string;
}

export const useDeleteInvestment = (
  options?: UseMutationOptions<any, Error, DeleteInvestmentPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["deleteInvestment"],
    mutationFn: async (data: DeleteInvestmentPayload) => {
      return axiosInstance
        .delete(`/investments/${data.uuid}`)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa usuwanie aktywa...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "delete-investment",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Aktywo zostało usunięte.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "delete-investment",
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas usuwania aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "delete-investment",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
